import type { SyntheticEvent } from 'react';
import React, { memo } from 'react';

import { Icon } from '@sravni/react-design-system';
import { ArrowLeft } from '@sravni/react-icons';

import { sendBackLinkClickEvent } from '@src/helpers/analyticsEvents';

import styles from './styles.module.scss';

type Props = {
  text: string;
  link: string;
  eventLabel: string;
};

export const BackLink = memo(({ link, text, eventLabel }: Props) => {
  const handleClick = (event: SyntheticEvent) => {
    event.stopPropagation();

    sendBackLinkClickEvent(eventLabel);
  };

  return (
    <div className={styles.wrapper}>
      <a onClick={handleClick} href={link} className={styles.link}>
        <Icon icon={<ArrowLeft />} size={16} />
        {text}
      </a>
    </div>
  );
});
